import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=348a89be&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=348a89be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a89be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348a89be')) {
      api.createRecord('348a89be', component.options)
    } else {
      api.reload('348a89be', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=348a89be&scoped=true&", function () {
      api.rerender('348a89be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gE1Q67ct3146/JS/comp/PopupDialog.vue"
export default component.exports